import React, { useState, useRef } from "react";
import ChatMessagesContainer from "./ChatMessagesContainer";
import ChatMessagesContainerCompsRenderer from "./ChatMessagesContainerCompsRenderer";

function ChatV2ContainerPanel({sessionId ,setChatHeadings,setSelectedIndex}) {
  const [leftWidth, setLeftWidth] = useState(50);
  const isDragging = useRef(false);
  const [isResizing, setIsResizing] = useState(false);
  const [intentData, setIntentData] = useState({ intent: null, data: [] });
  const [showHandle, setShowHandle] = useState(false);


  const handleMouseDown = () => {
    isDragging.current = true;
    setIsResizing(true);      // ⬅ Disable transitions while dragging
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    setIsResizing(false);     // ⬅ Re-enable transitions after drag ends
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;

    const container = document.getElementById("chat-v2-container");
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const newLeftWidth = ((e.clientX - rect.left) / rect.width) * 100;

    if (newLeftWidth > 20 && newLeftWidth < 80) {
      setLeftWidth(newLeftWidth);
    }
  };

  return (
    <div
      id="chat-v2-container"
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        position: "relative",
        userSelect: "none",
      }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={() => {
        handleMouseUp();
        setShowHandle(false);
      }}
    >
      {/* LEFT PANEL */}
      <div
        style={{
          width: intentData?.intent ? `${leftWidth}%` : "100%",
          minWidth: intentData?.intent ? "40%" : "100%",
          paddingRight: intentData?.intent ? "0.5rem" : "0",

          // ⬅ Smooth when toggling right panel, instant during drag
          transition: isResizing ? "none" : "width 0.25s ease",
        }}
      >
        <ChatMessagesContainer
          setIntentData={setIntentData}
          sessionId={sessionId} 
          setChatHeadings={setChatHeadings}
          setSelectedIndex={setSelectedIndex}
        />
      </div>

      {/* DRAG HANDLE (Only when intent exists) */}
      {intentData?.intent && (
        <div
          onMouseDown={handleMouseDown}
          onMouseEnter={() => setShowHandle(true)}
          onMouseLeave={() => setShowHandle(false)}
          style={{
            width: "0.6rem",
            cursor: "col-resize",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            zIndex: 10,
          }}
        >
          {/* divider line */}
          <div
            style={{
              position: "absolute",
              width: "0.01rem",
              height: "100%",
              background: "rgba(188, 199, 204, 0.45)",
            }}
          />

          {/* hover handle */}
          <div
            style={{
              width: "0.45rem",
              height: "1.8rem",
              background: "rgba(188, 199, 204, 0.88)",
              borderRadius: "0.35rem",
              opacity: showHandle ? 1 : 0,
              transition: "opacity 0.2s ease-in-out",
            }}
          />
        </div>
      )}

      {/* RIGHT PANEL */}
      {intentData?.intent && (
        <div
          style={{
            width: `${100 - leftWidth}%`,
            paddingLeft: "0.5rem",

            // ⬅ Same logic: animate only when not dragging
            transition: isResizing ? "none" : "width 0.25s ease",
          }}
        >
          <ChatMessagesContainerCompsRenderer
            intentData={intentData}
            setIntentData={setIntentData}
          />
        </div>
      )}
    </div>
  );
}

export default ChatV2ContainerPanel;
